var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarcadorUsuario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_428",
    x: 1.707,
    y: -2.834,
    width: 46.584,
    height: 58.834,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-marcadorUsuario"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marcadorUsuario",
    clipPath: "url(#clip-marcadorUsuario)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17219",
    "data-name": "Grupo 17219"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Trazado_428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_428-2",
    "data-name": "Trazado 428",
    d: "M19.292,2A14.281,14.281,0,0,0,5,16.292C5,27.01,19.292,42.833,19.292,42.833S33.583,27.01,33.583,16.292A14.281,14.281,0,0,0,19.292,2Zm0,19.4a5.1,5.1,0,1,1,5.1-5.1A5.106,5.106,0,0,1,19.292,21.4Z",
    transform: "translate(5.71 1.17)",
    fill: "#d94237"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_553",
    "data-name": "Elipse 553",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(19 11)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarcadorUsuario);
export default __webpack_public_path__ + "static/media/marcadorUsuario.1c9dff90c7628c69e3ae0e40c74232d6.svg";
export { ForwardRef as ReactComponent };